import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  timeout: 20000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imageService = {
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await axios.post(`${API_BASE_URL}/images/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        // no Authorization header – backend allows anonymous upload
      },
    });
    return data.url;
  },
};


export const wetlandService = {
  async createWetland(wetlandData) {
    const { data } = await apiClient.post('/wetlands', wetlandData);
    return data;
  },

  async getWetlands() {
    const { data } = await apiClient.get('/wetlands/resolved');
    const list = Array.isArray(data) ? data : [];
    return list.map((w) => {
      const lat = w?.location?.latitude;
      const lng = w?.location?.longitude;
      return {
        ...w,
        location: w.location
          ? {
              ...w.location,
              latitude: typeof lat === 'string' ? parseFloat(lat) : lat,
              longitude: typeof lng === 'string' ? parseFloat(lng) : lng,
            }
          : w.location,
      };
    });
  },

  async getWetlandById(id) {
    const { data } = await apiClient.get(`/wetlands/${id}`);
    return data;
  },

  async updateWetland(id, wetlandData) {
    const { data } = await apiClient.put(`/wetlands/${id}`, wetlandData);
    return data;
  },

  async deleteWetland(id) {
    const { data } = await apiClient.delete(`/wetlands/${id}`);
    return data;
  },
};

export default apiClient;
